import React, { useState } from 'react'

const ShowHideText = ({ text, minLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  // Show full text if it's shorter than minLength
  if (text.length <= minLength) return <p>{text}</p>

  return (
    <p>
      {isExpanded ? text : text.substring(0, minLength) + '...'}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="btn btn-link p-0 ms-1"
      >
        {isExpanded ? 'Show Less' : 'Show More'}
      </button>
    </p>
  )
}

export default ShowHideText
